export const filterOptionsTypes = {
    RADIO: 'radio',
    CHECKBOX: 'checkbox',
};
